import { useEffect, useState } from 'react'
import AdminLayout from '../../components/shell/AdminLayout'
import StatusCodesSection from '../../components/admin/StatusCodesSection'
import AssignmentsSection from '../../components/admin/AssignmentsSection'
import ActivitiesSection from '../../components/admin/ActivitiesSection'
import { getOpenTeams, type AccountTeam } from './accountStore'
import { getActivities, getQualifications, type Activity, type Qualification } from './catalogStore'

const SECTIONS = [
  { id: 'status-codes', label: 'Status codes' },
  { id: 'assignments', label: 'Assignments' },
  { id: 'activities', label: 'Activities' },
]

/**
 * The catalogs a schedule is built from: status codes, assignments, and
 * activities. The activities load here because two sections read them, the
 * assignments for their default activity and the activities for their own
 * list.
 */
export default function AdminCodesPage() {
  const [activities, setActivities] = useState<Activity[]>([])
  const [activitiesLoaded, setActivitiesLoaded] = useState(false)
  const [teams, setTeams] = useState<AccountTeam[]>([])
  const [qualifications, setQualifications] = useState<Qualification[]>([])

  useEffect(() => {
    let cancelled = false
    Promise.all([getActivities(), getOpenTeams(), getQualifications()]).then(([loadedActivities, loadedTeams, loadedQualifications]) => {
      if (cancelled) return
      setActivities(loadedActivities)
      setActivitiesLoaded(true)
      setTeams(loadedTeams)
      setQualifications(loadedQualifications)
    })
    return () => {
      cancelled = true
    }
  }, [])

  async function reloadActivities() {
    setActivities(await getActivities())
  }

  return (
    <AdminLayout current="codes" title="Codes & activities" subtitle="The status codes, assignments, and activities a schedule is built from">
      <nav aria-label="On this page" className="flex flex-wrap gap-2">
        {SECTIONS.map((section) => (
          <a
            key={section.id}
            href={`#${section.id}`}
            className="flex min-h-11 items-center justify-center rounded-control border border-line-strong px-3 text-small font-bold hover:bg-surface-2"
          >
            {section.label}
          </a>
        ))}
      </nav>
      <StatusCodesSection />
      <AssignmentsSection teams={teams} activities={activities} qualifications={qualifications} />
      <ActivitiesSection activities={activities} loaded={activitiesLoaded} onChanged={reloadActivities} />
    </AdminLayout>
  )
}
